var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "#00A094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.27,26.73l-5.49-5.48a13,13,0,1,0-3.53,3.54l5.48,5.48a2.5,2.5,0,0,0,3.54-3.54ZM3,14A11,11,0,1,1,14,25,11,11,0,0,1,3,14ZM28.85,28.85a.48.48,0,0,1-.7,0l-5.33-5.32c.24-.23.48-.47.7-.71l5.33,5.33a.49.49,0,0,1,.15.35A.47.47,0,0,1,28.85,28.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4,13.08a4,4,0,1,0-6.8,0A6,6,0,0,0,8,18a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3A6,6,0,0,0,17.4,13.08ZM14,9a2,2,0,1,1-2,2A2,2,0,0,1,14,9Zm3,10H11a1,1,0,0,1-1-1,4,4,0,0,1,2.1-3.5,3.86,3.86,0,0,0,3.8,0A4,4,0,0,1,18,18,1,1,0,0,1,17,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9cd183347b29d3046eaa061f2b116d1c.svg";
export { ForwardRef as ReactComponent };